import { css } from 'linaria';

export const allPurchasesModalSwiper = css`
  && {
    max-width: 580px;
    margin-left: 0;

    @media (--to-desktop) {
      padding-left: 0;
    }

    .swiper-button-next.swiper-button-next {
      right: -4px;
    }

    @media (--only-tablet) {
      .swiper-button-next {
        display: flex;
      }

      .swiper-button-prev {
        display: flex;
      }
    }
  }
`;

export const allPurchasesModalSlide = css`
  && {
    width: 180px;
    height: 240px;
    margin-right: 20px;

    @media (--only-mobile) {
      width: 136px;
      height: 144px;
      margin-right: 8px;
    }
  }
`;

export const allPurchasesModalContent = css`
  && {
    margin-bottom: 40px;

    @media (--only-mobile) {
      margin-bottom: 32px;
    }
  }
`;

export const allPurchasesModalText = css`
  margin-bottom: 24px;
`;

export const allPurchasesCategoryCard = css`
  && {
    @media (--only-mobile) {
      padding: 16px;
    }
  }
`;

export const allPurchasesModalImage = css`
  && {
    @media (--only-mobile) {
      width: 89px;
      height: 80px;
    }
  }
`;
